// removed by extract-text-webpack-plugin
module.exports = {"container":"EventInsight__container___GZq7a","content":"EventInsight__content___D7Jsz","mobileInsight":"EventInsight__mobileInsight___2esYm","eventConversion":"EventInsight__eventConversion___3QIgk","overallConversion":"EventInsight__overallConversion___1UISa","totalRevenue":"EventInsight__totalRevenue___1pxOE","revenueText":"EventInsight__revenueText___2Ppr5","bold":"EventInsight__bold___1thFA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/views/widgets/EventInsight.css
 ** module id = 711
 ** module chunks = 0
 **/